import React, { useState } from 'react';
import Header from './components/Header.jsx';
import HomePage from './components/HomePage.jsx';
import CartPage from './components/CartPage.jsx';
import CheckoutPage from './components/CheckoutPage.jsx';
import FavoritesPage from './components/FavoritesPage.jsx';
import Footer from './components/Footer.jsx';
import ConsultationPage from './components/ConsultationPage.jsx';
import PrivacyPolicyPage from './components/PrivacyPolicyPage.jsx';
import TermsOfUsePage from './components/TermsOfUsePage.jsx';
import ReturnPolicyPage from './components/ReturnPolicyPage.jsx';
import PaymentMethodsPage from './components/PaymentMethodsPage.jsx';
import ShippingPage from './components/ShippingPage.jsx';
import FAQPage from './components/FAQPage.jsx';
import { categorySlugs } from './components/categoriesData';
import CategoryPage from './components/CategoryPage';
import { getProductsByCategory } from './components/productsData';
import './App.css';
import ScrollToTopOnRouteChange from './components/ScrollToTopOnRouteChange.jsx';
import ScrollToTopButton from './components/ScrollToTopButton.jsx';
import GeminiChat from './components/GeminiChat.jsx';

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [currentPage, setCurrentPage] = useState('home');

  const addToCart = (product) => {
    setCartItems(prevItems => {
      const existingItem = prevItems.find(item => item.id === product.id);
      if (existingItem) {
        return prevItems.map(item =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        return [...prevItems, { ...product, quantity: 1 }];
      }
    });
  };

  const updateQuantity = (productId, newQuantity) => {
    setCartItems(prevItems => {
      if (newQuantity <= 0) {
        return prevItems.filter(item => item.id !== productId);
      }
      return prevItems.map(item =>
        item.id === productId ? { ...item, quantity: newQuantity } : item
      );
    });
  };

  const removeFromCart = (productId) => {
    setCartItems(prevItems => prevItems.filter(item => item.id !== productId));
  };

  const addToFavorites = (product) => {
    setFavorites(prevFavorites => {
      const isAlreadyFavorite = prevFavorites.some(item => item.id === product.id);
      if (!isAlreadyFavorite) {
        return [...prevFavorites, product];
      }
      return prevFavorites;
    });
  };

  const removeFromFavorites = (productId) => {
    setFavorites(prevFavorites => prevFavorites.filter(item => item.id !== productId));
  };

  const totalItemsInCart = cartItems.reduce((total, item) => total + item.quantity, 0);

  // خصائص مشتركة تُمرَّر لصفحات الفئات (نفس الشكل، بيانات مختلفة)
  const categoryPageProps = {
    totalItems: totalItemsInCart,
    totalFavorites: favorites.length,
    setCurrentPage,
    addToCart,
    addToFavorites,
    favorites
  };

  // خصائص مشتركة تُمرَّر لصفحات السياسات والمعلومات (كل واحدة فيها الهيدر والفوتر جوّاها)
  const legalPageProps = {
    totalItems: totalItemsInCart,
    totalFavorites: favorites.length,
    setCurrentPage
  };

const renderPage = () => {
  switch (currentPage) {
    case 'cart':
      return (
        <CartPage
          cartItems={cartItems}
          updateQuantity={updateQuantity}
          removeFromCart={removeFromCart}
          setCurrentPage={setCurrentPage}
        />
      );

    case 'checkout':
      return (
        <CheckoutPage
          cartItems={cartItems}
          setCurrentPage={setCurrentPage}
        />
      );

    case 'favorites':
      return (
        <FavoritesPage
          favorites={favorites}
          removeFromFavorites={removeFromFavorites}
          addToCart={addToCart}
          setCurrentPage={setCurrentPage}
        />
      );

    case 'consultation':
      return <ConsultationPage setCurrentPage={setCurrentPage} />;

    case 'privacy':
      return <PrivacyPolicyPage {...legalPageProps} />;

    case 'terms':
      return <TermsOfUsePage {...legalPageProps} />;

    case 'returns':
      return <ReturnPolicyPage {...legalPageProps} />;

    case 'payment':
      return <PaymentMethodsPage {...legalPageProps} />;

    case 'shipping':
      return <ShippingPage {...legalPageProps} />;

    case 'faq':
      return <FAQPage {...legalPageProps} />;

    default:
      break;
  }

  // جميع صفحات الفئات
  if (categorySlugs.includes(currentPage)) {
    return (
      <CategoryPage
        slug={currentPage}
        products={getProductsByCategory(currentPage)}
        {...categoryPageProps}
      />
    );
  }

  // الصفحة الرئيسية
  return (
    <HomePage
      addToCart={addToCart}
      addToFavorites={addToFavorites}
      favorites={favorites}
      setCurrentPage={setCurrentPage}
    />
  );
};

  // الهيدر/الفوتر المشترك يظهر بس في الصفحة الرئيسية، لأن باقي الصفحات
  // (الفئات وصفحات السياسات) بتجيب هيدر وفوتر بتاعها بنفسها
  const showSharedLayout = currentPage === 'home';

  return (
    <div className="App font-sans">
      {/* بترجع لأعلى الصفحة تلقائيًا كل ما currentPage يتغير */}
      <ScrollToTopOnRouteChange currentPage={currentPage} />

      {showSharedLayout && (
        <Header totalItems={totalItemsInCart} totalFavorites={favorites.length} setCurrentPage={setCurrentPage} />
      )}

      <main>
        {renderPage()}
      </main>

      {showSharedLayout && <Footer setCurrentPage={setCurrentPage} />}

      {/* زرار عائم بيظهر مع السكرول ويرجّع لأعلى الصفحة */}
      <ScrollToTopButton />

      {/* المساعد الصيدلاني الذكي - ظاهر في كل الصفحات */}
      <GeminiChat />
    </div>
  );
}

export default App;
